import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";
import { canAnyIn, canAtIn, type Me, type Needs } from "./can.ts";

export * from "./can.ts";

export function useMe() {
  const query = useQuery({ queryKey: ["me"], queryFn: () => api<Me>("/api/me"), staleTime: 60_000, retry: false });
  return {
    me: query.data,
    loading: query.isLoading,
    error: query.error,
    /** What the server would allow. It still checks every request; this only decides what to draw. */
    can: (needs: Needs) => canAnyIn(query.data, needs),
    canAt: (needs: string, scope: string) => canAtIn(query.data, needs, scope),
  };
}
